import { type SelectOption } from '../../../../../../components';
import { PAGE_TEXT } from '../../../../lang';

export enum IS_PI_TYPE {
  YES = 'YES',
  NO = 'NO',
}

export const isPIOptions: SelectOption[] = [
  {
    label: PAGE_TEXT.YES,
    value: IS_PI_TYPE.YES,
  },
  {
    label: PAGE_TEXT.NO,
    value: IS_PI_TYPE.NO,
  },
];
